/* eslint-disable */
import Vue from "vue";
import VueRouter from "vue-router";
import App from "./App.vue";

//Vuetify
import "vuetify/dist/vuetify.min.css";
import Vuetify from "vuetify";

import "material-design-icons-iconfont/dist/material-design-icons.css";
import "./styles/global.css";
import "./styles/employeeRequest.css";
import "font-awesome/css/font-awesome.min.css";

import VueSweetAlert from "vue-sweetalert";
import VeeValidate from "vee-validate";
import VueMoment from "vue-moment";

import VueTheMask from "vue-the-mask";

// Bootstrap Vue
import BootstrapVue from "bootstrap-vue/dist/bootstrap-vue.esm";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import VueSignaturePad from "vue-signature-pad";

// Vue Full-Calendar
import FullCalendar from "vue-full-calendar";
// CSS Full-Calendar
import "fullcalendar/dist/fullcalendar.min.css";
// router setup
import routes from "./routes/routes";

//store
import store from "./store";
//skeleton loader
import VueSkeletonLoader from "skeleton-loader-vue";

import { setupComponents } from "./config/setup-components";

/*
|----------------------------------------------------------------------
| VUE INSTANCES
|----------------------------------------------------------------------
*/

setupComponents(Vue);

//Vuetify
Vue.use(Vuetify);

//Store
Vue.use(store);

// Full calendar
Vue.use(FullCalendar);
// Signature pad
Vue.use(VueSignaturePad);
// Input Mask
Vue.use(VueTheMask);

// Plugin setup
Vue.use(VueSweetAlert);

// use in routing
Vue.use(VueRouter);

// Bootstrap vue
Vue.use(BootstrapVue);

// Form Validation
Vue.use(VeeValidate);

// Vue Moment
Vue.use(VueMoment);

//Skeleton
Vue.use(VueSkeletonLoader);

// // ==========================================
// // ILISI KINI SA IMONG DAA-N NGA PATCH:
// // ==========================================
// const originalPush = VueRouter.prototype.push;
// VueRouter.prototype.push = function push(location, onResolve, onReject) {
//   if (onResolve || onReject)
//     return originalPush.call(this, location, onResolve, onReject);
//   return originalPush.call(this, location).catch(err => {
//     // Kung NavigationDuplicated ang error, pasagdi lang (dili i-throw)
//     if (err.name === "NavigationDuplicated") {
//       return err;
//     }
//     throw err;
//   });
// };
// ==========================================
// ==========================================

/*
|----------------------------------------------------------------------
| GLOBAL SETUP
|----------------------------------------------------------------------
*/

window.axios = require("axios");
window.moment = require("moment-timezone/builds/moment-timezone-with-data.min");
window.store = require("store");
window.axios.defaults.baseURL =
  "https://endpoint.blueprintbusinesssolutionscorp.com";
// window.axios.defaults.baseURL = "http://localhost:9090";

/*
|----------------------------------------------------------------------
| CONFIGURE ROUTER
|----------------------------------------------------------------------
*/

const router = new VueRouter({
  routes,
  mode: "history"
});

/*
|----------------------------------------------------------------------
|  GLOBAL TEXT & DATE FORMATING 
|----------------------------------------------------------------------
*/

Vue.filter("uppercase", function(value) {
  if (!value) return "";
  return value.toUpperCase();
});

Vue.filter("capitalize", function(value) {
  if (!value) return "";
  value = value.toString();
  return value.replace(/\w\S*/g, function(txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
});

Vue.prototype.getDate = function(date) {
  if (!date) return "N/A";
  return moment(date).format("MMM DD YYYY");
};

Vue.prototype.getBirth = function(date) {
  return moment(date).format("MMM DD");
};

Vue.prototype.leaveStartDate = function(date) {
  return moment(date).format("MMM DD");
};

Vue.prototype.leaveEndDate = function(date) {
  return moment(date).format("DD, YYYY");
};

Vue.prototype.annivDate = function(date) {
  return moment(date).format("MMM DD");
};

Vue.prototype.calculate = function(sum1, sum2) {
  let a = sum1 != 0.0 ? sum1 : 0;
  let b = sum2 != 0.0 ? sum2 : 0;

  let total = a + b;
  return total;
};

Vue.prototype.years = function(value) {
  const currentYear = new Date().getFullYear();
  let years = [];
  for (let year = value; year <= currentYear; year++) {
    years.push(year);
  }
  return years;
};

Date.prototype.addHours = function(h) {
  this.setTime(this.getTime() + h * 60 * 60 * 1000);
  return this;
};

/*
|----------------------------------------------------------------------
| ROUTER GUARD
|----------------------------------------------------------------------
*/

router.beforeEach((to, from, next) => {
  if (
    to.matched.some(route => route.meta.requiresAuth) &&
    !store.state.USER_AUTH.isLoggedIn
  ) {
    next({ name: "Login-Layout" });
    return;
  }
  if (to.path === "dashboard" && store.state.USER_AUTH.isLoggedIn) {
    next({ name: "Dashboard" });
  }

  if (to.path === "/" && store.state.USER_AUTH.isLoggedIn) {
    next({ name: "Dashboard" });
  }
  document.title = `ESS - ${to.name}`;
  next();
});

/*
|----------------------------------------------------------------------
| GLOBAL HEADER INTERCEPTORS FOR TOKEN & CORS
|----------------------------------------------------------------------
*/

axios.interceptors.request.use(config => {
  config.headers.common["Authorization"] =
    "Bearer " + localStorage.getItem("token");
  config.headers.get["Accepts"] = "application/json";
  config.headers.get["Access-Control-Allow-Origin"] = "*";
  config.headers.get["Access-Control-Allow-Methods"] =
    "GET,PUT,POST,DELETE,PATCH,OPTIONS";
  return config;
});

axios.interceptors.response.use(undefined, function(error) {
  if (error) {
    const originalRequest = error.config;
    if (error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      localStorage.removeItem("token");
      localStorage.removeItem("emp_id");
      localStorage.removeItem("role_id");
      store.commit("USER_AUTH/LOGOUT_USER");
      router.push("/").catch(err => {
        if (err.name !== "NavigationDuplicated") throw err;
      });
    }
    return Promise.reject(error);
  }
});

/*
|----------------------------------------------------------------------
| VUE INITIALIZE
|----------------------------------------------------------------------
*/

new Vue({
  el: "#app",
  render: h => h(App),
  store,
  router
});



// WEBPACK FOOTER //
// ./src/main.js